import { render } from "./Gitlab.vue?vue&type=template&id=60694464"
import script from "./Gitlab.vue?vue&type=script&lang=js"
export * from "./Gitlab.vue?vue&type=script&lang=js"
script.render = render

export default script